import React from 'react'
import {Locale, StationType} from '../../config/constants'
import {ListMode} from '../user/stations/MapListNavbar'
import TagButtons from './TagButtons'
import styles from './MapButtons.scss'
import Search from '../../assets/icons/vanshare/Search.svg'
import SlidersSolid from '../../assets/icons/vanshare/SlidersSolid.svg'
import ListIcon from '../../assets/icons/List.svg'

export const MapSearchFilterPanel = ({
  onSearchOpen,
  onAdvancedSearchOpen,
  locationStr,
  queryDateStr,
  advancedFilterLabel,
  paramsArea,
  prefecture,
  stationType,
  locale
} : {
  onSearchOpen: () => void,
  onAdvancedSearchOpen: () => void,
  locationStr: string,
  queryDateStr: string,
  advancedFilterLabel: string,
  paramsArea?: string,
  prefecture?: string
  stationType: StationType,
  locale: Locale
}) => {
  return <div className={['d-lg-none', styles.searchArea].join(' ')}>
    <div className={[
      'c-pointer px-4 no-gutters',
      'd-flex justify-content-between align-items-center',
      styles.mapSearchBar
    ].join(' ')}
    >
      <div className="d-flex align-items-center" onClick={onSearchOpen}>
        <Search className="fa mr-2"/>
        <span>{locationStr}</span>
      </div>
      <div className={styles.dateSearchBar} onClick={onSearchOpen}>{queryDateStr || '~'}</div>
      <div className={styles.splitter}/>
      <div className="d-flex align-items-center font-weight-bold" onClick={onAdvancedSearchOpen}>
        <SlidersSolid className={['mr-2 fa', styles.icon].join(' ')}/>
        {advancedFilterLabel}
      </div>
    </div>
    <TagButtons
      locale={locale}
      area={paramsArea}
      prefecture={prefecture}
      stationType={stationType}
      mode={ListMode.map}
    />
  </div>
}

export const ToggleListModePanel = ({
  toggleListMode,
  switchModeLabel
} : {
  toggleListMode: () => void,
  switchModeLabel: string
}) => <div className={[
  'd-lg-none c-pointer font-weight-bold',
  'd-flex justify-content-center align-items-center',
  styles.switchListBtn
].join(' ')}
  onClick={toggleListMode}
>
  <ListIcon className="fa mr-2"/>
  <span>
    {switchModeLabel}
  </span>
</div>
